import { render, staticRenderFns } from "./TrainingProgramFormDialog.vue?vue&type=template&id=2f19f3f3"
import script from "./TrainingProgramFormDialog.vue?vue&type=script&lang=js"
export * from "./TrainingProgramFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports